import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Injectable({
    providedIn: 'root'
})
export class LanguageRouteService {
    constructor(private router: Router, private languageService: LocalizationService) {
        // Subscribe to NavigationEnd events.
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            // Parse current URL query parameters.
            const urlParams = new URLSearchParams(window.location.search);
            const lang = urlParams.get('lang');

            if (!lang) return;

            if (lang && lang.toLowerCase() === 'ar') {
                this.languageService.switchLanguage('ar');
            } else {
                this.languageService.switchLanguage('en');
            }
        });
    }
}
